import { IGameState } from 'State/Game/IGameState';
import { Random as RandomUtil } from 'Utility/Random';
import { Persona } from './Persona';

abstract class Random extends Persona {
    protected selectCardToPlay(state: IGameState, matches: string[]): [IGameState, string] {
        return [state, RandomUtil.getRandomItem(matches)];
    }
}

export class RandomNoCoins extends Random {
    enabled = false;
    readonly id = 'randomNoCoins';
    readonly playThrough = false;
}

export class RandomPlaythrough extends Random {
    enabled = true;
    readonly id = 'randomPlaythrough';
    readonly playThrough = true;
}